const defaults = {
    walletLectureIncomeInit: false,
    walletChannelIncomeInit: false,
    walletliveroomVIPIncomeInit: false,
};

export default (state = defaults, action) => {
    switch (action.type) {
    case 'WALLET_LECTURE_INCOME_INIT':
        return {
            ...state,
            walletLectureIncomeInit: true, ...action.payload,
            lectureIncomeList: [...action.payload.lectureIncome.data]
        };
    case 'WALLET_LECTURE_INCOME_LOAD_MORE':
        return {
            ...state,
            walletLectureIncomeInit: true, ...action.payload,
            lectureIncomeList: [...state.lectureIncomeList, ...action.payload.lectureIncome.data]
        };

    case 'WALLET_CHANNEL_INCOME_INIT':
        return {
            ...state,
            walletChannelIncomeInit: true, ...action.payload,
            channelIncomeList: [...action.payload.channelIncome.data]
        };
    case 'WALLET_CHANNEL_INCOME_LOAD_MORE':
        return {
            ...state,
            walletChannelIncomeInit: true, ...action.payload,
            channelIncomeList: [...state.channelIncomeList, ...action.payload.channelIncome.data]
        };


    case 'WALLET_LIVEROOM_VIP_INCOME_INIT':
        return {
            ...state,
            walletliveroomVIPIncomeInit: true, ...action.payload,
            liveroomVIPIncomeList: [...action.payload.liveroomVIPIncome.data.records]
        };
    case 'WALLET_LIVEROOM_VIP_INCOME_LOAD_MORE':
        return {
            ...state,
            walletliveroomVIPIncomeInit: true, ...action.payload,
            liveroomVIPIncomeList: [...state.liveroomVIPIncomeList, ...action.payload.liveroomVIPIncome.data.records]
        };


    case 'WALLET_INCOME_PAGE_UNMOUNT':
        return {
            ...state,
            walletLectureIncomeInit: false,
            walletChannelIncomeInit: false,
            walletliveroomVIPIncomeInit: false
        };
    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/walletLiveroomIncome.js